import { render, staticRenderFns } from "./ViewFirm.vue?vue&type=template&id=45bba842"
import script from "./ViewFirm.vue?vue&type=script&lang=js"
export * from "./ViewFirm.vue?vue&type=script&lang=js"
import style0 from "./ViewFirm.vue?vue&type=style&index=0&id=45bba842&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports